import './spinner.css';
export default {
  "modifiers": {
    "inline": "pf-m-inline",
    "xs": "pf-m-xs",
    "sm": "pf-m-sm",
    "md": "pf-m-md",
    "lg": "pf-m-lg",
    "xl": "pf-m-xl"
  },
  "spinner": "pf-v6-c-spinner",
  "spinnerPath": "pf-v6-c-spinner__path"
};